import { render, staticRenderFns } from "./tour-booking-dialog.vue?vue&type=template&id=6fc16990"
import script from "./tour-booking-dialog.vue?vue&type=script&lang=js"
export * from "./tour-booking-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports